import React from 'react';
import { FileTextIcon, CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export const FeaturedResources = () => {
  return <section className="my-12" data-id="element-2375">
      <h2 className="text-2xl font-serif font-bold text-slate-900 mt-10 mb-5 leading-tight border-b border-slate-200 pb-2 flex items-center" data-id="element-2376">
        <FileTextIcon className="h-5 w-5 text-slate-700 mr-2 inline" data-id="element-2377" />
        Evidence-Based Resources for Your Health Journey
      </h2>
      <p className="text-base text-slate-800 leading-relaxed mb-8" data-id="element-2378">
        Explore our collection of medically-reviewed articles and guides to help
        you better understand your health challenges and make informed
        decisions.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-2379">
        {/* Resource 1 */}
        <div className="border border-slate-200 rounded-lg overflow-hidden bg-white" data-id="element-2380">
          <div className="relative" data-id="element-2381">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/p9CjdyCWZXVxk86iLxCwDX/Screenshot_2025-09-20_at_11.21.22_AM.png" alt="Understanding Bacterial Biofilms" className="w-full h-48 object-cover" data-id="element-2382" />
            <div className="absolute top-3 left-3 bg-white/90 px-2 py-1 rounded text-xs font-medium text-slate-700 flex items-center" data-id="element-2383">
              <CheckCircleIcon className="h-3 w-3 text-green-600 mr-1" data-id="element-2384" />
              Medically Reviewed
            </div>
          </div>
          <div className="p-4" data-id="element-2385">
            <h3 className="font-serif font-semibold text-slate-900 text-lg mb-2" data-id="element-2386">
              Understanding Bacterial Biofilms: The Hidden Cause of Recurring
              Infections
            </h3>
            <p className="text-sm text-slate-600 mb-4" data-id="element-2387">
              Learn why most treatments for recurring vaginal infections fail
              and how breaking through bacterial biofilms can finally provide
              lasting relief.
            </p>
            <Link to="/adv-1" className="text-rose-600 font-medium text-sm flex items-center hover:text-rose-700" data-id="element-2388">
              Read the full article
              <ArrowRightIcon className="h-4 w-4 ml-1" data-id="element-2389" />
            </Link>
          </div>
        </div>
        {/* Resource 2 */}
        <div className="border border-slate-200 rounded-lg overflow-hidden bg-white" data-id="element-2390">
          <div className="relative" data-id="element-2391">
            <img src="https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80" alt="Menopause Transition" className="w-full h-48 object-cover" data-id="element-2392" />
            <div className="absolute top-3 left-3 bg-white/90 px-2 py-1 rounded text-xs font-medium text-slate-700 flex items-center" data-id="element-2393">
              <CheckCircleIcon className="h-3 w-3 text-green-600 mr-1" data-id="element-2394" />
              Medically Reviewed
            </div>
          </div>
          <div className="p-4" data-id="element-2395">
            <h3 className="font-serif font-semibold text-slate-900 text-lg mb-2" data-id="element-2396">
              Navigating the Menopause Transition: Evidence-Based Approaches
            </h3>
            <p className="text-sm text-slate-600 mb-4" data-id="element-2397">
              Discover clinically-validated solutions for hot flashes, sleep
              disruption, and other menopause symptoms without the risks of
              traditional HRT.
            </p>
            <a href="#" className="text-amber-600 font-medium text-sm flex items-center hover:text-amber-700" data-id="element-2398">
              Read the full article
              <ArrowRightIcon className="h-4 w-4 ml-1" data-id="element-2399" />
            </a>
          </div>
        </div>
        {/* Resource 3 */}
        <div className="border border-slate-200 rounded-lg overflow-hidden bg-white" data-id="element-2400">
          <div className="relative" data-id="element-2401">
            <img src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Hormonal Balance" className="w-full h-48 object-cover" data-id="element-2402" />
            <div className="absolute top-3 left-3 bg-white/90 px-2 py-1 rounded text-xs font-medium text-slate-700 flex items-center" data-id="element-2403">
              <CheckCircleIcon className="h-3 w-3 text-green-600 mr-1" data-id="element-2404" />
              Medically Reviewed
            </div>
          </div>
          <div className="p-4" data-id="element-2405">
            <h3 className="font-serif font-semibold text-slate-900 text-lg mb-2" data-id="element-2406">
              The Science of Hormonal Balance: Beyond Estrogen and Progesterone
            </h3>
            <p className="text-sm text-slate-600 mb-4" data-id="element-2407">
              Explore how the complex interplay of hormones affects your health
              and discover evidence-based approaches to restore balance
              naturally.
            </p>
            <a href="#" className="text-indigo-600 font-medium text-sm flex items-center hover:text-indigo-700" data-id="element-2408">
              Read the full article
              <ArrowRightIcon className="h-4 w-4 ml-1" data-id="element-2409" />
            </a>
          </div>
        </div>
      </div>
    </section>;
};